import Configurazioni from "../";

const routes = [
	{ name: "ConfigurazioniPage", path: "/configurazioni", component: Configurazioni.ConfigurazioniPage },
	{ name: "ConfigurazioniMagazzinoPage", path: "/configurazionemagazzino", component: Configurazioni.ConfigurazioniMagazzinoPage },
];

export default routes;
